
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class ExtensionFieldDialog extends Serenity.EntityDialog<ExtensionFieldRow, any> {
        protected getFormKey() { return ExtensionFieldForm.formKey; }
        protected getIdProperty() { return ExtensionFieldRow.Fields.FieldName; }
        protected getLocalTextPrefix() { return ExtensionFieldRow.localTextPrefix; }
        protected getNameProperty() { return ExtensionFieldRow.Fields.FieldName; }
        protected getService() { return ExtensionFieldService.baseUrl; }

        protected form = new ExtensionFieldForm(this.idPrefix);

        private editorOptions: Serenity.PropertyGrid;
        private formatterOptions: Serenity.PropertyGrid;

        constructor() {
            super();

            this.form.DataType.changeSelect2(() => {
                this.updateFieldNames();
                if (!this.form.FieldName.value && this.fieldNames && this.form.DataType.value) {
                    var first = Q.first(this.fieldNames, x => x.DataType === this.form.DataType.value);
                    if (first)
                        this.form.FieldName.value = first.FieldName;
                }
            });

            this.createEditorOptionsGrid();
            this.form.EditorType.changeSelect2(e => this.createEditorOptionsGrid());

            this.createFormatterOptionsGrid();
            this.form.FormatterType.changeSelect2(e => this.createFormatterOptionsGrid());
        }

        private createEditorOptionsGrid() {
            var el: JQuery;
            if (this.editorOptions) {
                el = this.editorOptions.element;
                this.editorOptions.destroy();
                this.editorOptions = null;
                el.html('');
            }
            else
                el = $('<div/>').insertAfter(this.form.EditorType.element.closest(".category"));

            var items: Serenity.PropertyItem[];
            var editorType = this.form.EditorType.value;
            if (editorType) {
                var et = Q.getLookup<DataReportEditorTypeItem>("Data.DataReportEditorType")
                    .itemById[editorType];
                if (et)
                    items = et.Options;
            }

            items = items || [];
            items.forEach((x, i) => {
                if (x.editorType == "Boolean") 
                    x.editorType = "Serenity.YesNoCheckEditor";
            });

            var index = Q.indexOf(items, x => x.name == "lookupKey");
            if (index > 0) {
                var item = items[index];
                items.splice(index, 1);
                items.splice(0, 0, item);
            }

            this.editorOptions = new Serenity.PropertyGrid(el, {
                items: items,
                mode: Serenity.PropertyGridMode.insert,
                idPrefix: this.idPrefix + "EditOpt_"
            });

            this.editorOptions.load({});
        }

        private createFormatterOptionsGrid() {
            var el: JQuery;
            if (this.formatterOptions) {
                el = this.formatterOptions.element;
                this.formatterOptions.destroy();
                this.formatterOptions = null;
                el.html('');
            }
            else
                el = $('<div/>').insertAfter(this.form.FormatterType.element.closest(".category"));

            var items: Serenity.PropertyItem[];
            var formatterType = this.form.FormatterType.value;
            if (formatterType) {
                var et = Q.getLookup<DataReportFormatterTypeItem>("Data.DataReportFormatterType")
                    .itemById[formatterType];
                if (et)
                    items = et.Options;
            }

            items = items || [];
            items.forEach((x, i) => {
                if (x.editorType == "Boolean") 
                    x.editorType = "Serenity.YesNoCheckEditor";
            });


            var index = Q.indexOf(items, x => x.name == "lookupKey");
            if (index > 0) {
                var item = items[index];
                items.splice(index, 1);
                items.splice(0, 0, item);
            }

            this.formatterOptions = new Serenity.PropertyGrid(el, {
                items: items,
                mode: Serenity.PropertyGridMode.insert,
                idPrefix: this.idPrefix + "FmtOpt_"
            });

            this.formatterOptions.load({});
        }

        getLoadByIdRequest(id: any) {
            var request = super.getLoadByIdRequest(id);
            return <ExtensionFieldRetrieveRequest>{
                FieldName: request.EntityId,
                TableSchema: this.entity ? this.entity.TableSchema : '?',
                Tablename: this.entity ? this.entity.Tablename : '?'
            } as any;
        }

        getSaveEntity() {
            var entity = super.getSaveEntity();
            entity.Tablename = this.entity.Tablename;
            entity.TableSchema = this.entity.TableSchema;
            
            var editorParams = {};
            this.editorOptions.save(editorParams);
            entity.EditorParams = $.toJSON(editorParams);
            
            var formatterParams = {};
            this.formatterOptions.save(formatterParams);
            entity.FormatterParams = $.toJSON(formatterParams);

            return entity;
        }

        get isExpression() {
            return (this.isNew() && this.entity && this.entity.Expression == '') || !!(this.entity != null && this.entity.Expression);
        }

        updateInterface() {
            super.updateInterface();

            var isExpression = this.isExpression;
            this.form.Expression.getGridField().toggle(isExpression);
            this.form.DataType.getGridField().toggle(!isExpression);
            Serenity.EditorUtils.setReadOnly(this.form.DataType, !this.isNew() || isExpression);
            Serenity.EditorUtils.setReadOnly(this.form.FieldName, !this.isNew() || isExpression);
            Serenity.EditorUtils.setRequired(this.form.Expression, isExpression);

            var isDev = Authorization.userDefinition.IsDevelopment;
            this.toolbar.element.toggle(!!isDev);

            if (!isDev) {
                this.applyChangesButton.hide();
                this.saveAndCloseButton.hide();
                this.deleteButton.hide();
                Serenity.EditorUtils.setReadonly(this.element.find(":input"), true);
            }
        }

        private updateFieldNames() {
            var fieldName = this.form.FieldName.value;
            this.form.FieldName['clearItems']();
            var dataType = this.form.DataType.value;
            if (this.fieldNames && dataType) {
                for (var x of this.fieldNames) {
                    if (x.DataType === dataType && (!x.FieldAlias || !this.entity || this.entity.FieldName))
                        this.form.FieldName['addOption'](x.FieldName, x.FieldName, null, !!x.FieldAlias);
                }
                this.form.FieldName.value = fieldName;
            }
        }

        public fieldNames: ExtensionFieldRow[];

        public set dataTypes(value: string[]) {
            if (!value)
                return;

            for (var s of value)
                if (s && s.length && !Q.any(this.form.DataType.items, x => x.id == s)) {
                    this.form.DataType['addOption'](s, s);
                }
        }

        getDeleteOptions() {
            var opt = super['getDeleteOptions'] as Q.ServiceOptions<Serenity.DeleteResponse>;
            opt.request = <ExtensionFieldDeleteRequest>{
                TableSchema: this.entity.TableSchema,
                Tablename: this.entity.Tablename,
                FieldName: this.entity.FieldName
            };
            return opt;
        }

        loadEntity(entity: ExtensionFieldRow) {

            if (entity && entity.FieldName &&
                !Q.any(this.form.FieldName.items, x => x.id == entity.FieldName))
                this.form.FieldName['addOption'](entity.FieldName, entity.FieldName);

            var dataType = this.form.DataType.value;

            super.loadEntity(entity);

            if (!this.form.DataType.value)
                this.form.DataType.value = dataType;

            if (this.isNew() && !this.isExpression)
                this.updateFieldNames();

            this.createEditorOptionsGrid();
            this.editorOptions.load($.parseJSON(Q.trimToNull(entity.EditorParams) || "{}"));

            this.createFormatterOptionsGrid();
            this.formatterOptions.load($.parseJSON(Q.trimToNull(entity.FormatterParams) || "{}"));

        }
    }
}